module.exports = __webpack_public_path__ + "static/media/marrakesh.77d08421.jpg";